
  import React from "react";
import { motion } from "framer-motion";
import StickyNavbar from "../navbar";

const Chapter1Questions = () => {
  const questions = [
    "What are the key objectives of the research cycle?",
    "Define the term 'research problem' and provide an example.",
    "How do you identify the magnitude of a problem in the research context?",
    "What sources can be used to gather information about an existing problem?",
    "Why is it important to assess existing solutions to a problem?",
    "Explain the process of narrowing down a research question.",
    "What is the significance of a literature review in the research cycle?",
    "Describe a situation where identifying potential causes of a problem is critical.",
    "What role do stakeholders play in defining the research scope?",
    "How does the research cycle guide the planning of a health intervention?"
  ];

  return (
    <div>
      <StickyNavbar />
      <div className="bg-gray-50 min-h-screen p-8 mt-10">
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-8"
        >
          <h1 className="text-3xl font-bold text-blue-900">
            Chapter 1 Questions
          </h1>
        </motion.div>
        <motion.ul
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="space-y-4 text-lg"
        >
          {questions.map((question, index) => (
            <motion.li
              key={index}
              whileHover={{ scale: 1.05, x: 10 }}
              className="bg-white shadow-md p-4 rounded-lg border border-gray-200"
            >
              {index + 1}. {question}
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </div>
  );
};

export default Chapter1Questions;
